import firebase from 'firebase';
import 'firebase/firestore';

var config = {
  apiKey: "AIzaSyB4JaCH96CXpgKbpBQ0GlqP7UxJfwFEMYA",
  authDomain: "mayo-3d-54f0b.firebaseapp.com",
  databaseURL: "https://mayo-3d-54f0b.firebaseio.com",
  projectId: "mayo-3d-54f0b",
  storageBucket: "mayo-3d-54f0b.appspot.com",
  messagingSenderId: "876438402273",
  appId: "1:876438402273:web:ecbb47f07da841499533a0"
};
firebase.initializeApp(config);

// firebase utils
const db = firebase.firestore();
const auth = firebase.auth();
// const googleProvider = new firebase.auth.GoogleAuthProvider();
// const facebookProvider = new firebase.auth.FacebookAuthProvider();
const currentUser = auth.currentUser;
const storage = firebase.storage();
const functions = firebase.functions();
const fieldValue = firebase.functions.FieldValue

// date issue fix according to firebase
const settings = {};
db.settings(settings);

// firebase collections

export default {
  db,
  auth,
  functions,
  currentUser,
  fieldValue,
  storage,
  // googleProvider,
  // facebookProvider,
};
